<miq-ticket-detail-header [ticketDetail]="ticketDetail" (backToListEvent)="backToList()"></miq-ticket-detail-header>

<div class="ticket-detail-con">
  <div class="flex-grid">
    <div class="col-1-3">
      <miq-ticket-detail-additional-info
        [ticketDetail]="ticketDetail"
        [page]="page"
        [isProfile]="isProfile"
        (jiraNumberCtrlEvent)="handleJiraNumberEvt($event)"
        (estimatedReleaseDateCtrlEvent)="handleEstimatedReleaseDateEvt($event)"
      >
      </miq-ticket-detail-additional-info>
    </div>

    <div class="col-2-3 ticket-detail">
      <div class="col">
        <miq-ticket-detail-status
          [ticketDetail]="ticketDetail"
          [ticketStatuses]="ticketStatuses"
          [isProfile]="isProfile"
          [isInGroup]="isInGroup"
          (statusChangeEvent)="updateStatus($event)"
        >
        </miq-ticket-detail-status>
      </div>

      <miq-ticket-detail-info [ticketDetail]="ticketDetail"></miq-ticket-detail-info>

      <div class="col">
        <miq-ticket-detail-attachments [ticketDetail]="ticketDetail"></miq-ticket-detail-attachments>
      </div>
      <div class="col">
        <miq-comments
          [title]="'shared.ticketComments' | xTranslate"
          [type]="'tickets'"
          [conversationId]="ticketDetail.id"
        ></miq-comments>
      </div>
    </div>
  </div>
  <div class="flt-right submit" *ngIf="!isProfile">
    <button
      mat-flat-button
      color="primary"
      (click)="submit()"
      class="fx--mr-sm"
      [disabled]="!(estimatedReleaseDateCtrl.dirty || jiraNumberCtrl.dirty)"
      l10nTranslate
    >
      shared.submit
    </button>
    <button mat-flat-button color="primary" (click)="assignTo()" l10nTranslate>shared.assign</button>
  </div>
</div>
